export default __webpack_public_path__ + "static/media/IMSA-Video-22-6-22.40e7b54f.mp4";